/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact/compat';

type LegendRenderedContextType = {
  isGetPreferredSizeReady?: (isReady: boolean) => void;
  width?: number;
  height?: number;
};

export const LegendRenderedContext = createContext<LegendRenderedContextType>({});
